import React, { useState, useEffect} from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import LogoutIcon from '@mui/icons-material/Logout';
import Table from './Table';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import AnchorIcon from '@mui/icons-material/Anchor';
import Tooltip from '@mui/material/Tooltip';
import Axios from 'axios';
import Chip from '@mui/material/Chip';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../store/auth';
import { typeActions } from '../../store/type';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';



const Copyright = props => {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="/">
        Operadora Portuaria Centroamericana
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
const logo = require('../../assets/OPC-logo.webp');
const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);



const mdTheme = createTheme();

const DashboardContent = () => {
  const [isLoad, setLoad ] = useState(false);
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const typeIs = useSelector( state => state.type.typeIs );
  const token = useSelector (state => state.auth.token );
  const privilegios = useSelector (state => state.auth.privilegios);
  const username = useSelector (state => state.auth.username );
  const count = useSelector( state => state.count.count );


  const dispatch = useDispatch();

  const logoutHandler = () => {
  navigate('/login', { replace: true });
  dispatch(authActions.logout());
  dispatch(typeActions.None());
  }

  const bethplanHandler = () => {
  dispatch(typeActions.Plan());
  }
  const newsHandler = () => {
  dispatch(typeActions.News());
  }
  const dashboardHandler = () =>{
  dispatch(typeActions.None());
  }



  const [plan, setPlan] = useState([]);
  useEffect(() => {
    if(privilegios.plan){
      setLoad(true);
    Axios({
    headers: {
      'authorization':  `Bearer ${token}`
    },
    url: "api/planAtraques",
  })
    .then((response) => {
      setPlan(response.data);
      if(response.status === 200 ){
        setLoad(false);
      }
    })
    .catch((error) => {
      if(error.response.status === 401) {
        dispatch(authActions.logout());
      }
    });
  }
 }, [count]);

  const [news, setNews] = useState([]);
  useEffect(() => {
    if(privilegios.news){
      setLoad(true);
    Axios({
    headers: {
      'authorization':  `Bearer ${token}`
    },
    url: "api/Noticias",
  })
    .then((response) => {
      setNews(response.data);
      if(response.status === 200 ){
        setLoad(false);
      }
    })
    .catch((error) => {
      if(error.response.status === 401) {
        dispatch(authActions.logout());
      }
    });
  } }, [count]);

  
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px', // keep right padding when drawer closed
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: '36px',
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              <img src={logo} />
            </Typography>
            <Stack direction="row" spacing={1}>
              <Chip sx={{ color: 'white', fontSize: 18 }} icon={<AccountCircleIcon style={{ color: 'white' }} />} label={username} variant="outlined" />
            </Stack>
            <IconButton onClick={logoutHandler} color="inherit">
            <Tooltip title="Cerrar sesión">
                <LogoutIcon />
              </Tooltip>
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          
          <List component="nav">
            <React.Fragment>
              <ListItemButton onClick={dashboardHandler}>
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItemButton>
             {  privilegios.plan ?  
             <ListItemButton onClick={bethplanHandler}>
                <ListItemIcon>
                  <AnchorIcon />
                </ListItemIcon>
                <ListItemText primary="Formatos" />
              </ListItemButton>: null }
          {  privilegios.news  ? <ListItemButton onClick={newsHandler}> 
                <ListItemIcon>
                  <NewspaperIcon />
                </ListItemIcon>
                <ListItemText primary="Noticias" />
              </ListItemButton>: null }
            </React.Fragment>
          </List>
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          <Container sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
             {isLoad ? <Box sx={{ width: 900 }}>
                <Skeleton />
                <Skeleton animation="wave" />
                <Skeleton animation={false} />
              </Box> : null} 
                { typeIs === 'plan' && isLoad === false ? <Table data={plan} /> : null}
                { typeIs === 'news' && isLoad === false ? <Table data={news} /> : null}
              </Grid>
            </Grid>
            <Copyright sx={{ pt: 4 }} />
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

 const Dashboard = () => {
  return <DashboardContent />;
}

export default Dashboard;